function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { AxiosError } from 'axios';
import { createApi } from '@reduxjs/toolkit/query/react';
import { larkiApi } from '../../utilities/api';
import { processJobList } from '../actions';
import { redirectTo } from '../../hooks/useRedirect';
import routes from '../../routes/constants';
import { _addMetadata, METADATA_PREFIX } from '../../utilities/bookmark';
import objectUtilities from '../../utilities/object';
export var LarkiUnauthorizedAccessToJobError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(LarkiUnauthorizedAccessToJobError, Error1);
    function LarkiUnauthorizedAccessToJobError(originalError) {
        _class_call_check(this, LarkiUnauthorizedAccessToJobError);
        var _this;
        _this = _call_super(this, LarkiUnauthorizedAccessToJobError, [
            'You are not authorized to access this job'
        ]), _define_property(_this, "originalError", void 0);
        _this.originalError = originalError;
        return _this;
    }
    return LarkiUnauthorizedAccessToJobError;
}(_wrap_native_super(Error));
function larkiApiBaseQuery() {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var url, method, data, params, headers, result, err, _err_response, _err_response1, _err_response2;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = param.url, method = param.method, data = param.data, params = param.params, headers = param.headers;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            larkiApi({
                                url: url,
                                method: method,
                                data: data,
                                params: params,
                                headers: headers
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            {
                                data: result.data
                            }
                        ];
                    case 3:
                        err = _state.sent();
                        if (_instanceof(err, AxiosError)) {
                            ;
                            if (((_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status) === 401) {
                                redirectTo(routes.login);
                            }
                            return [
                                2,
                                {
                                    error: {
                                        status: (_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : _err_response1.status,
                                        data: ((_err_response2 = err.response) === null || _err_response2 === void 0 ? void 0 : _err_response2.data) || err.message
                                    }
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                error: {
                                    data: err
                                }
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
}
export var RTK_API_REDUCER_PATH = 'rtk';
export var rtkApi = createApi({
    reducerPath: RTK_API_REDUCER_PATH,
    baseQuery: larkiApiBaseQuery(),
    tagTypes: [
        'Project',
        'User'
    ],
    endpoints: function(build) {
        return {
            /**
     * Don't use directly, use `useUser` instead.
     */ getUserProfile: build.query({
                query: function() {
                    return {
                        url: 'user/profile'
                    };
                },
                providesTags: [
                    'User'
                ]
            }),
            /**
     * Get projects associated with the current user.
     *
     * `getUserProjects` should have to wait until the user has been fetched
     *  so the `isAdmin` value is up to date.
     *
     * Usage:
     * ```
     * const currentUser = ();
     * const {...} = useGetUserProjectsQuery({skip: !currentUser.isSuccess})
     * ```
     */ getUserProjects: build.query({
                query: function(param) {
                    var isAdmin = param.isAdmin, _param_includeDemo = param.includeDemo, includeDemo = _param_includeDemo === void 0 ? false : _param_includeDemo;
                    return {
                        url: 'project',
                        params: {
                            isAdmin: isAdmin,
                            includeDemo: includeDemo,
                            inviteStatus: [
                                'accepted'
                            ]
                        }
                    };
                },
                providesTags: [
                    'Project'
                ],
                transformResponse: function(data) {
                    var _data_projects;
                    return {
                        jobToProjectId: (_data_projects = data.projects) === null || _data_projects === void 0 ? void 0 : _data_projects.reduce(function(acc, project) {
                            if (project.jobs.length === 0) {
                                return acc;
                            }
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = project.jobs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var job = _step.value;
                                    acc[job.id] = project.id;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return acc;
                        }, {}),
                        projects: processJobList(data),
                        counts: data.statusCounts
                    };
                }
            }),
            /**
     * Create an new job.
     */ createJob: build.mutation({
                query: function(data) {
                    return {
                        url: 'job',
                        method: 'POST',
                        data: data
                    };
                },
                invalidatesTags: [
                    'Project'
                ]
            }),
            // TODO: add appropriate Response & Request type
            updateJob: build.mutation({
                query: function(param) {
                    var id = param.id, data = param.data;
                    return {
                        url: "/job/".concat(id),
                        method: 'PUT',
                        data: data
                    };
                },
                invalidatesTags: [
                    'Project'
                ]
            }),
            /**
     * Get a job by ID.
     */ getJob: build.query({
                queryFn: /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(jobId, _, __, baseQuery) {
                        var resp, job, _ref, smartSelections, property, ret;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        baseQuery({
                                            url: "/job/".concat(jobId)
                                        })
                                    ];
                                case 1:
                                    resp = _state.sent();
                                    if (resp.error) {
                                        if (resp.error.status === 403) {
                                            return [
                                                2,
                                                {
                                                    error: new LarkiUnauthorizedAccessToJobError(resp.error.originalError)
                                                }
                                            ];
                                        }
                                        return [
                                            2,
                                            {
                                                error: resp.error
                                            }
                                        ];
                                    }
                                    job = resp.data;
                                    return [
                                        4,
                                        Promise.all([
                                            new Promise(function(resolve, reject) {
                                                if (!job.place_geometry) return resolve([]);
                                                return Promise.resolve(baseQuery({
                                                    url: "/engine/product/selections",
                                                    method: 'POST',
                                                    data: {
                                                        location: {
                                                            lng: job.place_geometry.coordinates[0],
                                                            lat: job.place_geometry.coordinates[1]
                                                        },
                                                        address: job.full_address,
                                                        city: job.city,
                                                        state: job.state,
                                                        postcode: job.postcode
                                                    }
                                                })).then(function(resp) {
                                                    if (resp.error) return reject(resp.error);
                                                    var data = resp.data;
                                                    return resolve(_to_consumable_array(data.property_vicinity).concat([
                                                        data.neighbourhood
                                                    ], _to_consumable_array(data.buildings), _to_consumable_array(data.roads)));
                                                }).catch(reject);
                                            }),
                                            new Promise(function(resolve, reject) {
                                                if (!job.place_geometry) return resolve(null);
                                                return Promise.resolve(baseQuery({
                                                    url: '/engine/selections/property',
                                                    method: 'POST',
                                                    data: {
                                                        location: {
                                                            lat: job.place_geometry.coordinates[1],
                                                            lng: job.place_geometry.coordinates[0]
                                                        }
                                                    }
                                                })).then(function(resp) {
                                                    if (resp.error) return reject(resp.error);
                                                    return resolve(resp.data);
                                                }).catch(reject);
                                            })
                                        ])
                                    ];
                                case 2:
                                    _ref = _sliced_to_array.apply(void 0, [
                                        _state.sent(),
                                        2
                                    ]), smartSelections = _ref[0], property = _ref[1];
                                    ret = _object_spread_props(_object_spread({}, job), {
                                        smartSelections: smartSelections,
                                        property: property
                                    });
                                    return [
                                        2,
                                        {
                                            data: ret
                                        }
                                    ];
                            }
                        });
                    });
                    return function(jobId, _, __, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                providesTags: [
                    'Project'
                ]
            }),
            /**
     * Shape downloads.
     */ geospatialDownload: build.mutation({
                query: function(param) {
                    var jobId = param.jobId, shapes = param.shapes, fileType = param.fileType;
                    return {
                        url: "/job/".concat(jobId, "/geospatial/download"),
                        method: 'POST',
                        data: {
                            shapes: shapes,
                            fileType: fileType
                        }
                    };
                }
            }),
            /**
     * Get a project by ID.
     */ getProject: build.query({
                query: function(param) {
                    var projectId = param.projectId;
                    return {
                        url: "/project/".concat(projectId)
                    };
                },
                providesTags: [
                    'Project'
                ]
            }),
            /**
     * Check access.
     */ checkProjectAccess: build.query({
                query: function(param) {
                    var projectId = param.projectId;
                    return {
                        url: "/project/".concat(projectId, "/check-access")
                    };
                }
            }),
            checkJobAccess: build.query({
                query: function(param) {
                    var jobId = param.jobId;
                    return {
                        url: "/job/".concat(jobId, "/check-access")
                    };
                }
            }),
            /**
     * Request access to a page, with an existing share token.
     */ requestAccess: build.mutation({
                queryFn: /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(param, _, __, baseQuery) {
                        var shareToken, projectId, jobId, url, resp;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    shareToken = param.shareToken, projectId = param.projectId, jobId = param.jobId;
                                    url = shareToken ? "/project/bookmark/".concat(shareToken, "/request") : projectId ? "/project/".concat(projectId, "/request-access") : jobId ? "/job/".concat(jobId, "/request-access") : null;
                                    if (!url) throw new Error('Needed one of [shareToken, projectId, jobId]');
                                    return [
                                        4,
                                        baseQuery({
                                            url: url,
                                            method: 'POST'
                                        })
                                    ];
                                case 1:
                                    resp = _state.sent();
                                    if (resp.error) {
                                        if (resp.error.status === 409) {
                                            return [
                                                2,
                                                {
                                                    data: null
                                                }
                                            ];
                                        }
                                        return [
                                            2,
                                            {
                                                error: resp.error
                                            }
                                        ];
                                    }
                                    return [
                                        2,
                                        {
                                            data: resp.data
                                        }
                                    ];
                            }
                        });
                    });
                    return function(_, _1, __, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                // if we request access to a project, we need to invalidate its cache
                //  so that the next time we try and view it, we don't get an unauthorized error
                invalidatesTags: [
                    'Project'
                ]
            }),
            /**
     * Open a bookmark.
     */ openBookmark: build.query({
                queryFn: /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(param, _, __, baseQuery) {
                        var shareToken, redirectToRequestAccess, resp, _resp_error_data_bookmark, _resp_error_data, _resp_error_data_userProject, _resp_error_data1, shareToken1, metadata, metadataFlat, redirectUrl;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    shareToken = param.shareToken, redirectToRequestAccess = param.redirectToRequestAccess;
                                    return [
                                        4,
                                        baseQuery({
                                            url: "/ln/".concat(shareToken)
                                        })
                                    ];
                                case 1:
                                    resp = _state.sent();
                                    if (resp.error) {
                                        if (resp.error.status === 403) {
                                            ;
                                            shareToken1 = (_resp_error_data = resp.error.data) === null || _resp_error_data === void 0 ? void 0 : (_resp_error_data_bookmark = _resp_error_data.bookmark) === null || _resp_error_data_bookmark === void 0 ? void 0 : _resp_error_data_bookmark.share_token;
                                            if (shareToken1 && redirectToRequestAccess) {
                                                return [
                                                    2,
                                                    {
                                                        data: _object_spread_props(_object_spread({}, resp.error.data), {
                                                            redirectUrl: routes.requestAccess.withShareToken(shareToken1)
                                                        })
                                                    }
                                                ];
                                            }
                                            if (((_resp_error_data1 = resp.error.data) === null || _resp_error_data1 === void 0 ? void 0 : (_resp_error_data_userProject = _resp_error_data1.userProject) === null || _resp_error_data_userProject === void 0 ? void 0 : _resp_error_data_userProject.invite_status) === 'rejected') {
                                                return [
                                                    2,
                                                    {
                                                        data: _object_spread_props(_object_spread({}, resp.error.data), {
                                                            isRejected: true
                                                        })
                                                    }
                                                ];
                                            }
                                        }
                                        return [
                                            2,
                                            {
                                                data: resp.error.data
                                            }
                                        ];
                                    }
                                    metadata = resp.data.bookmark.metadata;
                                    metadataFlat = metadata ? objectUtilities.flatten(metadata, METADATA_PREFIX) : null;
                                    redirectUrl = _addMetadata(resp.data.bookmark.redirect_url, metadataFlat);
                                    return [
                                        2,
                                        {
                                            data: _object_spread_props(_object_spread({}, resp.data), {
                                                redirectUrl: redirectUrl
                                            })
                                        }
                                    ];
                            }
                        });
                    });
                    return function(_, _1, __, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            reinitiateJob: build.mutation({
                query: function(param) {
                    var jobId = param.jobId;
                    return {
                        url: "/job/".concat(jobId, "/order/reinitiate"),
                        method: 'POST'
                    };
                }
            }),
            supersedeActivity: build.mutation({
                query: function(param) {
                    var projectId = param.projectId, activityId = param.activityId, isSuperseded = param.isSuperseded;
                    return {
                        url: "/project/".concat(projectId, "/activity/").concat(activityId, "/supersede"),
                        method: 'PATCH',
                        data: {
                            isSuperseded: isSuperseded
                        }
                    };
                }
            })
        };
    }
});
export var useGetUserProfileQuery = rtkApi.useGetUserProfileQuery, useGetUserProjectsQuery = rtkApi.useGetUserProjectsQuery, useCreateJobMutation = rtkApi.useCreateJobMutation, useUpdateJobMutation = rtkApi.useUpdateJobMutation, useGetJobQuery = rtkApi.useGetJobQuery, useGeospatialDownloadMutation = rtkApi.useGeospatialDownloadMutation, useGetProjectQuery = rtkApi.useGetProjectQuery, useCheckProjectAccessQuery = rtkApi.useCheckProjectAccessQuery, useCheckJobAccessQuery = rtkApi.useCheckJobAccessQuery, useRequestAccessMutation = rtkApi.useRequestAccessMutation, useLazyOpenBookmarkQuery = rtkApi.useLazyOpenBookmarkQuery, useOpenBookmarkQuery = rtkApi.useOpenBookmarkQuery, useReinitiateJobMutation = rtkApi.useReinitiateJobMutation, useSupersedeActivityMutation = rtkApi.useSupersedeActivityMutation;
